import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

// Define the prop types
interface CardProps {
  image: string; // URL of the image
  name: string; // Name of the person
  testimonial: string; // Testimonial text
}

const Card: React.FC<CardProps> = ({ image, name, testimonial }) => {
  const [showOverlay, setShowOverlay] = useState<boolean>(false);

  return (
    <motion.div
      className="relative overflow-hidden min-h-[200px] p-4 sm:p-6 md:p-8 border border-[#1f1f1f] w-full flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6 md:gap-10 bg-[#2c2c2c] text-white rounded-xl shadow-lg hover:cursor-pointer transition-all"
      key={image}
      onHoverStart={() => setShowOverlay(true)}
      onHoverEnd={() => setShowOverlay(false)}
    >
      {/* Image section */}
      <motion.div className="relative w-[130px] md:w-[250px]  rounded-xl overflow-hidden mb-4 md:mb-0">
        {/* Image */}
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover rounded-xl bg-white"
          style={{ aspectRatio: "1 / 1" }} // Ensures 1:1 aspect ratio
        />
      </motion.div>

      {/* Text section */}
      <div className="flex flex-col w-full text-left ">
        <h3 className="text-sm sm:text-xl md:text-2xl font-bold">{name}</h3>
        <p className="text-xs sm:text-sm md:text-base text-gray-300 mt-1 sm:mt-2">
          {testimonial}
        </p>
      </div>
    </motion.div>
  );
};

export default Card;
